/**
 * Grantable simplified-portal features.
 *
 * `id` must match Types::Enums::FeatureKeyEnumType on the backend.
 */
const FEATURE_ENTITLEMENTS = [
  { id: "REQUEST_ROLE", labelId: "Settings.Users.FeatureEntitlements.RequestRole" },
  { id: "APPLICANT_BOARD", labelId: "Settings.Users.FeatureEntitlements.ApplicantBoard" },
  { id: "MOVE_APPLICANTS", labelId: "Settings.Users.FeatureEntitlements.MoveApplicants" },
  { id: "BUILD_ROLE_WITH_AI", labelId: "Settings.Users.FeatureEntitlements.BuildRoleWithAi" },
  { id: "INTERVIEW_SCHEDULING", labelId: "Settings.Users.FeatureEntitlements.InterviewScheduling" },
];

export default FEATURE_ENTITLEMENTS;
